(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["semana-resuelta"] && !Shopify.designMode) return;
  try {
    
class SemanaResueltaStore extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.form = this.querySelector('[data-sr-product-form]');
    this.dialog = this.querySelector('[data-sr-offer]');
    this.error = this.querySelector('[data-sr-error]');
    this.busy = false;
    if (!this.form) return;
    this.form.addEventListener('submit', event => {
      event.preventDefault();
      if (this.busy) return;
      if (this.dataset.preview === 'true') {
        this.querySelector('[data-sr-preview-dialog]').showModal();
        return;
      }
      if (this.dialog && !this.offerSeen) {
        this.offerSeen = true;
        this.dialog.showModal();
      } else {
        this.purchase(false);
      }
    });
    this.querySelectorAll('[data-sr-close]').forEach(button => {
      button.addEventListener('click', () => button.closest('dialog').close());
    });
    this.querySelector('[data-sr-add-offer]')?.addEventListener('click', () => this.purchase(true));
    this.querySelector('[data-sr-skip-offer]')?.addEventListener('click', () => this.purchase(false));
  }
  async purchase(withOffer) {
    if (this.busy) return;
    this.busy = true;
    this.error.textContent = '';
    const buttons = [...this.querySelectorAll('button')];
    const buttonStates = buttons.map(button => button.disabled);
    buttons.forEach(button => { button.disabled = true; });
    this.setAttribute('aria-busy', 'true');
    const root = (this.dataset.root || '/').replace(/\/?$/, '/');
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 20000);
    try {
      const primary = Number(this.form.querySelector('[name="id"]').value);
      const addon = Number(this.dataset.addon);
      if (!Number.isSafeInteger(primary) || primary <= 0) throw new Error('variant');
      if (withOffer && (!Number.isSafeInteger(addon) || addon <= 0 || addon === primary)) throw new Error('addon');
      const cartResponse = await fetch(root + 'cart.js', { credentials:'same-origin', signal:controller.signal });
      if (!cartResponse.ok) throw new Error('cart');
      const cart = await cartResponse.json();
      const desired = withOffer ? [primary, addon] : [primary];
      const items = desired.filter(id => !cart.items.some(item => Number(item.variant_id) === id)).map(id => ({ id, quantity:1 }));
      if (items.length) {
        const response = await fetch(root + 'cart/add.js', {
          method:'POST', credentials:'same-origin',
          headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
          body:JSON.stringify({ items }), signal:controller.signal
        });
        if (!response.ok) throw new Error('add');
      }
      this.dialog?.close();
      const checkout = this.querySelector('[data-sr-checkout-button]');
      checkout.disabled = false;
      checkout.click();
    } catch (error) {
      this.dialog?.close();
      this.error.textContent = this.dataset.error;
      this.error.focus();
    } finally {
      clearTimeout(timeout);
      this.busy = false;
      buttons.forEach((button, index) => { button.disabled = buttonStates[index]; });
      this.removeAttribute('aria-busy');
    }
  }
}
if (!customElements.get('semana-resuelta-store')) customElements.define('semana-resuelta-store', SemanaResueltaStore);


  } catch(e) { console.error(e); }
})();
})();
